import { createAsyncAction, createReducer, isActionOf } from 'typesafe-actions'
import { combineReducers } from 'redux'
import { combineEpics } from 'redux-observable'
import { filter, map, switchMap } from 'rxjs/operators'
import { apiRequests } from '../../../http/config'
import { NotificationMethod, NotificationSettingsRow } from '../../../responses/profile'
import { payloadReducer } from '../../../utils/redux-utils'
import { toastFailedResponse } from '../../../components/controls/Toaster/Toaster'
import { RootEpic } from '../../root'
import { ID } from '../../../types/UtilityTypes'

const actions = {
    notificationSettings: createAsyncAction(
        '@PROFILE/NOTIFICATION_SETTINGS_REQUEST',
        '@PROFILE/NOTIFICATION_SETTINGS_SUCCESS',
        '@PROFILE/NOTIFICATION_SETTINGS_FAILURE',
    )<ID, NotificationSettingsRow[], void>(),
    notificationMethods: createAsyncAction(
        '@PROFILE/NOTIFICATION_METHODS_REQUEST',
        '@PROFILE/NOTIFICATION_METHODS_SUCCESS',
        '@PROFILE/NOTIFICATION_METHODS_FAILURE',
    )<ID, NotificationMethod[], void>(),
}

export { actions as profileActions }

export interface ProfileState {
    notificationSettings: NotificationSettingsRow[],
    notificationMethods: NotificationMethod[],
}

export const profileReducer = combineReducers<ProfileState>({
    notificationSettings: createReducer([] as NotificationSettingsRow[])
        .handleAction(actions.notificationSettings.success, payloadReducer),
    notificationMethods: createReducer<NotificationMethod[]>([])
        .handleAction(actions.notificationMethods.success, payloadReducer)
})

const notificationSettings: RootEpic = action$ => action$.pipe(
    filter(isActionOf(actions.notificationSettings.request)),
    switchMap(action => apiRequests.users.notificationSettings({ params: { id: action.payload } })),
    map(res => res.response.success ?
        actions.notificationSettings.success(res.response.rows) :
        actions.notificationSettings.failure(toastFailedResponse(res.response, 'Не удалось получить настройки уведомлений'))
    ),
)

const notificationMethods: RootEpic = action$ => action$.pipe(
    filter(isActionOf(actions.notificationMethods.request)),
    switchMap(action => apiRequests.users.notificationMethods({params: {userId: action.payload}})),
    map(res => res.response.success ?
        actions.notificationMethods.success((res.response.rows)):
        actions.notificationMethods.failure(toastFailedResponse(res.response, 'Не удалось получить методы уведомлений'))
    )
)

export const profileEpic = combineEpics(notificationSettings, notificationMethods)